var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"lighten-12 content",attrs:{"fluid":""}},[_c('v-data-table',{attrs:{"fixed-header":true,"headers":_vm.tableorders,"items":_vm.TableOrders,"item-key":"id","hide-default-footer":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }